(() => {
  if (window.oggoCrossSellLoaded) return;
  window.oggoCrossSellLoaded = true;
  const source = document.querySelector('oggo-cross-sell-source');
  if (!source) return;
  const config = JSON.parse(source.querySelector('[data-cross-sell-config]').textContent);
  let cart = config.cart;
  let busy = false;
  let preferredDirection = null;
  const tr = config.locale === 'tr';
  const root = window.Shopify?.routes?.root || '/';
  // Collection membership is loaded page by page, without a fixed product-ID list.
  async function collectionIds(handles) {
    const ids = new Set();
    for (const handle of handles) {
      for (let page = 1; ; page++) {
        const response = await fetch(root + 'collections/' + encodeURIComponent(handle) + '/products.json?limit=250&page=' + page, {signal: AbortSignal.timeout(5000)});
        if (!response.ok) throw new Error('Collection unavailable');
        const data = await response.json();
        for (const product of data.products) ids.add(Number(product.id));
        if (data.products.length < 250) break;
      }
    }
    return [...ids];
  }
  const membershipReady = Promise.all([collectionIds(config.bagCollections), collectionIds(config.shoeCollections)])
    .then(([bags, shoes]) => { config.bags = bags; config.shoes = shoes; })
    .catch(() => {}); // Server-rendered current collection IDs remain as fallback.
  const text = (turkish, english) => tr ? turkish : english;
  const popup = document.createElement('dialog');
  popup.className = 'oggo-cross-sell-popup';
  popup.setAttribute('aria-label', text('Kombinini tamamla', 'Complete your look'));
  const close = document.createElement('button');
  close.type = 'button';
  close.className = 'oggo-cross-sell-popup__close';
  close.setAttribute('aria-label', text('Kapat', 'Close'));
  close.textContent = '×';
  close.addEventListener('click', () => popup.close());
  const popupMount = document.createElement('div');
  popupMount.setAttribute('data-oggo-cross-sell-mount', '');
  popup.append(close, popupMount);
  document.body.append(popup);
  popup.addEventListener('click', event => {
    if (event.target === popup) {
      const rect = popup.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) popup.close();
    }
  });
  let popupTimer;
  let completingOffer = false;
  function showOffer() {
    clearTimeout(popupTimer);
    popupTimer = setTimeout(() => {
      if (!popupMount.hidden && !popup.open) popup.showModal();
    }, 500);
  }
  function render() {
    const ids = new Set(cart.items.map(item => item.product_id));
    const hasBag = config.bags.some(id => ids.has(id));
    const hasShoe = config.shoes.some(id => ids.has(id));
    const direction = preferredDirection || (hasShoe && !hasBag ? 'bags' : hasBag && !hasShoe ? 'shoes' : null);
    for (const mount of document.querySelectorAll('[data-oggo-cross-sell-mount]')) {
      mount.replaceChildren();
      mount.hidden = !direction;
      if (!direction) continue;
      mount.append(source.querySelector(`template[data-offer="${direction}"]`).content.cloneNode(true));
      let count = 0;
      for (const card of mount.querySelectorAll('[data-product-id]')) {
        if (ids.has(Number(card.dataset.productId))) card.remove(); else count++;
      }
      mount.hidden = count === 0;
    }
    // Ürün sayfası: çanta sayfasında kampanyalı ayakkabılar, ayakkabı sayfasında Suvea çantalar
    for (const mount of document.querySelectorAll('[data-oggo-kombin-pdp]')) {
      const productId = Number(mount.dataset.productId);
      const offer = config.bags.includes(productId) ? 'shoes' : config.shoes.includes(productId) ? 'bags' : null;
      mount.replaceChildren();
      mount.hidden = !offer;
      if (!offer) continue;
      mount.append(source.querySelector(`template[data-offer="${offer}"]`).content.cloneNode(true));
      let count = 0;
      for (const card of mount.querySelectorAll('[data-product-id]')) {
        if (ids.has(Number(card.dataset.productId))) card.remove(); else count++;
      }
      mount.hidden = count === 0;
    }
    if (popupMount.hidden && popup.open) popup.close();
  }
  // Varyant değişince tema ürün bloklarını yeniden çiziyor; kartı tekrar yerleştir
  document.addEventListener('product:rerender', () => setTimeout(render), true);
  let lastAddedId = null;
  document.addEventListener('variant:add', event => {
    const items = event.detail?.items || [];
    const added = Array.isArray(items) ? items : [items];
    lastAddedId = Number(added[added.length - 1]?.product_id);
  });
  let cartRevision = 0;
  document.addEventListener('cart:change', async event => {
    if (!event.detail?.cart?.items) return;
    const revision = ++cartRevision;
    const addedId = lastAddedId;
    const isCompleting = completingOffer;
    await membershipReady;
    if (revision !== cartRevision) return;
    preferredDirection = event.detail.baseEvent === 'variant:add' && !isCompleting
      ? (config.bags.includes(addedId) ? 'shoes' : config.shoes.includes(addedId) ? 'bags' : null)
      : null;
    cart = event.detail.cart; render();
    if (event.detail.baseEvent === 'variant:add' && !isCompleting && preferredDirection) showOffer();
  });
  document.addEventListener('cart-drawer:refreshed', render);
  window.addEventListener('pageshow', async event => {
    if (event.persisted) { try { const r = await fetch(root + 'cart.js'); if (r.ok) {cart = await r.json();render();} } catch {} }
  });
  document.addEventListener('change', event => {
    if (!event.target.matches('[data-cross-sell-variant]')) return;
    event.target.closest('[data-product-id]').querySelector('[data-cross-sell-add]').disabled = !event.target.value;
  });
  document.addEventListener('click', async event => {
    const button = event.target.closest('[data-cross-sell-add]');
    if (!button || busy) return;
    const block = button.closest('.oggo-cross-sell');
    // Ürün sayfasındaki karttan eklenince geri bildirim olarak yan sepet açılır
    const fromProductPage = !!button.closest('[data-oggo-kombin-pdp]');
    const id = button.closest('[data-product-id]').querySelector('select').value;
    if (!id) return;
    busy = true; button.disabled = true; button.setAttribute('aria-busy', 'true');
    const status = block.querySelector('[role="status"]');
    status.textContent = text('Sepete ekleniyor…', 'Adding to cart…');
    let added = false;
    try {
      const sections = [];
      document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', {bubbles:true, detail:{sections}}));
      const response = await fetch(root + 'cart/add.js', {method:'POST', headers:{'Content-Type':'application/json','X-Requested-With':'XMLHttpRequest'}, body:JSON.stringify({items:[{id:Number(id),quantity:1}],sections:[...new Set(sections)].slice(0,5),sections_url:location.pathname})});
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || text('Ürün eklenemedi.', 'Could not add this item.'));
      added = true;
      completingOffer = true; preferredDirection = null; popup.close();
      if (document.querySelector('.cart-page')) { location.assign(root + 'cart'); return; }
      const cartResponse = await fetch(root + 'cart.js');
      if (!cartResponse.ok) throw new Error('cart-refresh');
      cart = await cartResponse.json(); cart.sections = result.sections;
      if (!cart.sections || Object.values(cart.sections).some(value => !value)) {location.assign(root + 'cart');return;}
      document.documentElement.dispatchEvent(new CustomEvent('variant:add', {bubbles:true, detail:{items:result.items,cart}}));
      document.documentElement.dispatchEvent(new CustomEvent('cart:change', {bubbles:true, detail:{baseEvent:'variant:add',onSuccessDo:fromProductPage ? 'force_open_drawer' : 'do_not_open_drawer',cart}}));
    } catch (error) {
      if (added) {location.assign(root + 'cart');return;}
      status.textContent = text('Ürün eklenemedi. Stok ve bağlantıyı kontrol edip tekrar deneyin.', 'Could not add this item. Check availability and your connection, then try again.');
    } finally { completingOffer = false; busy = false; button.disabled = false; button.removeAttribute('aria-busy'); }
  });
  membershipReady.then(render);
  render();
  if (document.querySelector('.cart-page')) showOffer();
})();
